const rankings = [
  { rank: 1, title: '某顶流疑似恋情曝光，粉丝集体破防', heat: '9.8万', trend: 'up', tag: '爆' },
  { rank: 2, title: '热门综艺录制现场发生激烈争执', heat: '8.5万', trend: 'up', tag: '热' },
  { rank: 3, title: '知名网红直播中突然宣布退网', heat: '7.2万', trend: 'up', tag: '热' },
  { rank: 4, title: '某品牌代言人被曝合约纠纷细节', heat: '6.1万', trend: 'new', tag: '新' },
  { rank: 5, title: '跨年晚会节目单提前流出引争议', heat: '5.4万', trend: 'down', tag: '议' },
  { rank: 6, title: '明星工作室凌晨发声明否认传闻', heat: '4.8万', trend: 'up', tag: '热' },
];

function RankBadge({ rank }: { rank: number }) {
  const colors = [
    'bg-primary-500 text-background-50',
    'bg-accent-500 text-background-50',
    'bg-secondary-500 text-background-50',
  ];
  const colorClass = rank <= 3 ? colors[rank - 1] : 'bg-background-200 text-foreground-500';
  return (
    <span className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${colorClass}`}>
      {rank}
    </span>
  );
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">热度榜单</h2>
          <span className="text-xs text-foreground-400">24小时实时排行</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-bold text-primary-600 bg-primary-100 px-1.5 py-0.5 rounded whitespace-nowrap">{item.tag}</span>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors truncate">{item.title}</h3>
                </div>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <span className="text-xs">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-foreground-400"></i>}
                  {item.trend === 'new' && <i className="ri-add-circle-line text-accent-500"></i>}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}